import React, { useState } from "react";
import { Icons } from "../../components/common/Icons";
import { useInternData } from "../../context/InternContext";
import AvatarUpload from "../../components/common/AvatarUpload";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/api";
import InternEIDCard from "./InternEIDCard";
import "../../assets/styles/Intern/ProfileSection.css";

function ProfileSection() {
  const { profileDetails, uploadedDocs, internData } = useInternData();
  const { user, refreshUser } = useAuth();
  const [showEID, setShowEID] = useState(false);

  const handleDownload = async (doc) => {
    try {
      if (doc.id) {
        await api.downloadDocById(doc.id, doc.name || doc.doc_name || 'document');
      } else {
        // Fallback: try getDocUrl
        const res = await api.getDocUrl(doc.id);
        if (res?.url) {
          await api.downloadFile(res.url, res.name || doc.name || 'document');
        } else {
          alert('Document download not available');
        }
      }
    } catch (e) {alert('Download failed: ' + e.message);}
  };

  return (
    <>
    {/* E-ID Card - collapsible section (same as employee style) */}
    <div className="card animate-in mb-24" style={{ marginBottom: 24 }}>
      <div
        onClick={() => setShowEID(v => !v)}
        style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "16px 20px", cursor: "pointer", userSelect: "none",
          borderRadius: showEID ? "12px 12px 0 0" : 12,
          background: showEID
            ? "linear-gradient(135deg,#0a2244,#1a5fa8)"
            : "linear-gradient(135deg,#f0f7ff,#e8f0fe)",
          transition: "all .25s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22 }}>🪪</span>
          <div>
            <div style={{ fontSize: 14, fontWeight: 800, color: showEID ? "#fff" : "#0a2244" }}>E-ID Card</div>
            <div style={{ fontSize: 11, color: showEID ? "rgba(255,255,255,.65)" : "#64748b", marginTop: 1 }}>
              {showEID ? "Click to collapse" : "Click to view your identity card"}
            </div>
          </div>
        </div>
        <span style={{ fontSize: 18, color: showEID ? "#fff" : "#1a5fa8", transition: "transform .25s", display: "inline-block", transform: showEID ? "rotate(180deg)" : "rotate(0deg)" }}>
          ▼
        </span>
      </div>
      {showEID && (
        <div style={{ padding: "16px 20px", borderTop: "1px solid #dbeafe", display: "flex", justifyContent: "center" }}>
          <InternEIDCard />
        </div>
      )}
    </div>

    <div className="grid-2 mb-24">
      <div className="card animate-in delay-3">
        <div className="card-header"><div className="card-title">Profile Details</div><div className="view-only-badge"><Icons.Eye /> Read Only</div></div>
        <div className="card-body">
          <div className="profilesection-inline-1">
            <AvatarUpload
              currentAvatar={user?.avatar}
              name={internData.name || user?.name}
              size={64}
              editable={true}
              onUploaded={() => refreshUser?.()} />
            <div>
              <div className="profilesection-inline-2">{internData.name || user?.name}</div>
              <div className="profilesection-inline-3">{internData.role || 'Intern'}</div>
              <div className="profilesection-inline-4">{user?.emp_id || internData.id || user?.id}</div>
            </div>
          </div>
          {profileDetails.map((p, i) =>
          <div className="profile-field" key={i}><div className="profile-label">{p.label}</div><div className="profile-value">{p.value}</div></div>
          )}
        </div>
      </div>
      <div className="card animate-in delay-4">
        <div className="card-header"><div className="card-title">Uploaded Documents</div><div className="card-subtitle">{uploadedDocs.length} documents</div></div>
        <div className="card-body">
          {uploadedDocs.length === 0 ?
          <div className="profilesection-inline-5">No documents uploaded yet</div> :
          uploadedDocs.map((d, i) =>
          <div className="upload-doc" key={i}>
              <div><div className="upload-doc-name">📎 {d.name}</div><div className="upload-doc-date">Uploaded: {d.date}</div></div>
              <div className="doc-download profilesection-inline-6" onClick={() => handleDownload(d)}>
                <Icons.Download /> Download
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    </>) ;

}

export default ProfileSection;